import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class InventoriesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getLogs(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + '/logs' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getLots(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + '/lots' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/inventories/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventories/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/inventories/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUnusable(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + '/unusable' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async putUnusable(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventories/' + id + '/unusable' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getSettingBranch(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/inventories/' + id + '/setting-branch' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateSettingBranch(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/inventories/' + id + '/setting-branch' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class InventoryLotsApi {
	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/inventory-lots/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Inventories = new InventoriesApi();
export const InventoryLots = new InventoryLotsApi();
